import React from 'react';
import './FeatureStyles.css';

const DiscoveryProVideo = () => (
  <div className="feature-animation" style={{ outline: '1px solid #e5e7eb' }}>
    <video
      autoPlay
      loop
      muted
      playsInline
      style={{ filter: 'brightness(1.05)' }}
    >
      <source src="/discovery.mp4" type="video/mp4" />
    </video>
  </div>
);

const DiscoveryProFeature = {
  icon: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <circle cx="11" cy="11" r="8" />
      <path d="M21 21l-4.35-4.35" />
      <path d="M11 8v6M8 11h6" />
    </svg>
  ),
  title: "Discovery",
  description: "Deep-dive into your codebase and workflows. AI scans your frontend components, backend APIs, and user journeys to automatically map your entire application. Generate comprehensive test coverage based on real code structure, not guesswork.",
  highlight: null,
  animation: <DiscoveryProVideo />
};

export default DiscoveryProFeature;
